import React, { useContext } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { IntlContext } from "./index";
import messages from "components/messagesDescription";
import { formatMoney } from "../EnrollmentDataUtil";
import { useDispatch } from "react-redux";
import { setSelectedPlan } from "../../../../actions/otherBenefitsActions";

const OtherBenefitPlans = ({ account, benefit, member }) => {
  const intl = useContext(IntlContext);
  const dispatch = useDispatch();
  const handleSelectPlan = (accountId, benefitId, memberKey, plan) => {
    dispatch(setSelectedPlan(accountId, benefitId, memberKey, plan));
  };

  return (
    <div className="grid__wrapper plan-container">
      {member.plans.map(subPlan => (
        <div key={subPlan.id} className="grid__item grid__item--three product-panel__plan">
          <div style={{ height: "1rem", marginBottom: "1rem" }}>
            {subPlan.isDefault && (
              <div className="product-plan__badge">
                {intl.formatMessage(messages.defaultDescription)}
              </div>
            )}
          </div>
          <div className="product-plan-wrapper">
            <button
              style={{ alignItems: "center" }}
              onClick={() =>
                handleSelectPlan(account.accountId, benefit.id, member.memberKey, subPlan)
              }
              className={classnames("product-plan", "product-plan--selectable", {
                "product-plan--active": subPlan.isSelected,
              })}
            >
              <div className="product-plan__details" style={{ textAlign: "center" }}>
                <span>
                  <strong>
                    {intl.formatMessage({ id: subPlan.name, defaultMessage: subPlan.name })}
                  </strong>
                </span>
                {subPlan.price === 0 ? (
                  <strong>{formatMoney(subPlan.price)}</strong>
                ) : (
                  <span>
                    {subPlan.price > 0
                      ? intl.formatMessage(messages.enrollment.spendDescription)
                      : intl.formatMessage(messages.enrollment.creditDescription)}{" "}
                    <strong>{formatMoney(Math.abs(subPlan.price))}</strong>
                  </span>
                )}
              </div>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

OtherBenefitPlans.propTypes = {
  benefit: PropTypes.object.isRequired,
  member: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
};

export default OtherBenefitPlans;



// WEBPACK FOOTER //
// ./components/employee/shop/other-benefits/OtherBenefitPlans.js